import { render, staticRenderFns } from "./Settings.yaml?vue&type=template&id=cac47994&component"
import script from "./Settings.yaml?vue&type=script&lang=ts&component"
export * from "./Settings.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports